import { useState } from 'react';
import { User, Mail, Shield, CreditCard, X } from 'lucide-react';
import api from '../../api';

const EditUserModal = ({ onClose, user }) => {
    const [formData, setFormData] = useState({
        id: user._id,
        name: user?.name,
        email: user?.email,
        role: user?.role,
        subscription: user?.subscription,
    });

    const roles = ['user', 'admin', 'superAdmin'];
    const subscriptions = ['normal', 'premium', 'premiumPlus'];

    const handleInputChange = (field, value) => {
        setFormData((prev) => ({
            ...prev,
            [field]: value,
        }));
    };

    const handleSave = () => {
        api.put('/admin/edit-user', {
            id: formData.id,
            subscription: formData.subscription,
            role: formData.role
        }).then((res) => {
            const response = res.data;
            if(response.statusCode === 200) {
                onClose();
            }else{
                console.log(res)
                console.log("something went wrong while editing the user")
            }
        });
    };

    const handleCancel = () => {
        onClose();
    };

    return (
        <>
            {/* DaisyUI Modal Structure */}
            <div className="modal modal-open">
                <div className="modal-box relative max-w-md">
                    {/* Header */}
                    <div className="flex items-center justify-between mb-6">
                        <h2 className="text-xl font-bold flex items-center gap-2">
                            <User className="w-5 h-5 text-primary" />
                            Edit User
                        </h2>
                        <button
                            onClick={handleCancel}
                            className="btn btn-sm btn-circle btn-ghost absolute right-2 top-2"
                        >
                            <X className="w-4 h-4" />
                        </button>
                    </div>

                    {/* Form Content */}
                    <div className="space-y-4">
                        {/* Name Field - Read Only */}
                        <div className="form-control">
                            <label className="label">
                                <span className="label-text flex items-center gap-2">
                                    <User className="w-4 h-4 text-accent" />
                                    Name
                                </span>
                            </label>
                            <input
                                type="text"
                                className="input input-bordered w-full input-disabled"
                                value={formData.name}
                                readOnly
                            />
                        </div>

                        {/* Email Field - Read Only */}
                        <div className="form-control">
                            <label className="label">
                                <span className="label-text flex items-center gap-2">
                                    <Mail className="w-4 h-4 text-primary" />
                                    Email
                                </span>
                            </label>
                            <input
                                type="email"
                                className="input input-bordered w-full input-disabled"
                                value={formData.email}
                                readOnly
                            />
                        </div>

                        {/* Role Field */}
                        <div className="form-control">
                            <label className="label">
                                <span className="label-text flex items-center gap-2">
                                    <Shield className="w-4 h-4 text-warning" />
                                    Role
                                </span>
                            </label>
                            <select
                                className="select select-bordered w-full"
                                value={formData.role}
                                onChange={(e) =>
                                    handleInputChange('role', e.target.value)
                                }
                            >
                                {roles.map((role) => (
                                    <option key={role} value={role}>
                                        {role}
                                    </option>
                                ))}
                            </select>
                        </div>

                        {/* Subscription Field */}
                        <div className="form-control">
                            <label className="label">
                                <span className="label-text flex items-center gap-2">
                                    <CreditCard className="w-4 h-4 text-info" />
                                    Subscription
                                </span>
                            </label>
                            <select
                                className="select select-bordered w-full"
                                value={formData.subscription}
                                onChange={(e) =>
                                    handleInputChange(
                                        'subscription',
                                        e.target.value
                                    )
                                }
                            >
                                {subscriptions.map((subscription) => (
                                    <option
                                        key={subscription}
                                        value={subscription}
                                    >
                                        {subscription}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>

                    {/* Action Buttons */}
                    <div className="modal-action">
                        <button
                            onClick={handleCancel}
                            className="btn btn-outline"
                        >
                            Cancel
                        </button>
                        <button
                            onClick={handleSave}
                            className="btn btn-primary"
                        >
                            Save Changes
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default EditUserModal;
